<template>
  <div class="menu-view d-flex flex-column">
    <div v-if="!collasped" class="menu-overlay"></div>
    <Slide
      disableEsc
      @openMenu="toggleSidebar"
      @closeMenu="toggleSidebar"
      :closeOnNavigation="true"
    >
      <div v-if="company" class="sidebar-details d-flex flex-column align-items-center">
        <b-img
          width="80"
          :src="company.logo.lenght>0? company.logo[0]:'/img/default-logo.png'"
          alt
          class="logo"
        />
        <p v-if="company" class="company-name">{{company.company_name}}</p>
        <p v-if="menu" class="menu-name">{{menu.menu_name}}</p>
      </div>
      <div class="divider"></div>
      <div v-for="(menu, index) in leftmenu" :key="index">
        <div @click="$router.push(menu.to)" class="menu-item mb-1">
          <span class="icon mr-2">
            <b-icon :icon="menu.icon"></b-icon>
          </span>
          <span>{{menu.name}}</span>
        </div>
      </div>
    </Slide>
    <!-- <div @click="toggleSidebar" class="burger-icon">
      <b-icon icon="list"></b-icon>
    </div>-->

    <Cart />
    <router-view />
  </div>
</template>

<script>
import Cart from "./components/customer/Cart";
import { auth } from "../Firebase/firebase";
import { Slide } from "vue-burger-menu";
export default {
  components: {
    Cart,
    Slide
  },
  data() {
    return {
      username: null,
      menu_slug: null,
      table: {
        number: 0,
        message: ""
      },
      callingWaiter: false,
      isCalling: false,
      showPopover: false,
      menuOpen: true,
      notificationsOpen: false,

      collasped: true,
      window: {
        width: 0,
        height: 0
      }
    };
  },
  methods: {
    async fetchMenu() {
      const response = await this.$store.dispatch("MenuView/getCurrentMenu", {
        username: this.username.toLowerCase(),
        menu_slug: this.menu_slug.toLowerCase()
      });
      this.fetchCategories();
    },
    async fetchCategories() {
      this.searchingCategories = true;
      const response = await this.$store.dispatch("Menu/fetchMenuCategories", {
        categories: this.menu.categories,
        companyId: this.company.id
      });
      this.searchingCategories = false;
      return response;
    },
    callWaiter() {
      this.isCalling = true;
      this.$store
        .dispatch("MenuView/callWaiter", {
          companyId: this.company.id,
          menuId: this.menu.id,
          table: this.table,
          companyName: this.username,
          menu_slug: this.menu_slug
        })
        .then(() => {
          this.isCalling = false;
          this.callingWaiter = true;
          localStorage.callingWaiter = this.callingWaiter;
          localStorage.table = JSON.stringify(this.table);
        });
    },

    endRequest() {
      this.$store
        .dispatch("MenuView/endRequest", {
          companyId: this.company.id,
          menuId: this.menu.id,
          table: this.table
        })
        .then(() => {
          localStorage.callingWaiter = false;
          this.callingWaiter = false;
          this.table.message = "";
          localStorage.table = JSON.stringify({ ...this.table });
          this.onCloseWaiter();
        });
    },

    onOpenWaiter() {
      this.$refs.popover.$emit("open");
    },
    onCloseWaiter() {
      this.$refs.popover.$emit("close");
    },
    toggleSidebar() {
      this.collasped = !this.collasped;
    }
  },
  computed: {
    menu() {
     
      return this.$store.state.MenuView.currentMenu;
    },
    company() {
    
      return this.$store.state.MenuView.currentCompany;
    },
    categories() {
      return this.$store.state.Menu.menuCategories;
    },
    leftmenu() {
      const menus = [
        {
          name: "Home",
          to: `/${this.username}/${this.menu_slug}/`,
          icon: "house-door",
          nameSpace: "home"
        },
        {
          name: "Orders",
          to: `/${this.username}/${this.menu_slug}/orders`,
          icon: "inbox-fill",
          nameSpace: "account"
        },
        {
          name: "Checkout",
          to: `/${this.username}/${this.menu_slug}/checkout`,
          icon: "inbox-fill",
          nameSpace: "checkout"
        }
      ];
      return menus;
    }
  },

  mounted() {
    this.username = this.$route.params.username;
    this.menu_slug = this.$route.params.menu_slug;
    const localCallingWaiter = localStorage.callingWaiter
      ? JSON.parse(localStorage.callingWaiter)
      : false;
    if (localCallingWaiter) {
      this.callingWaiter = localStorage.callingWaiter;
      this.table = JSON.parse(localStorage.table);
    } else {
      this.callingWaiter = false;
      this.table = {
        number: 0,
        message: ""
      };
    }
  
    if (!auth.currentUser) {
      this.$store.dispatch("Auth/anonSignup");
    }
    this.fetchMenu();
  },
};
</script>

<style>
.menu-view {
  background: #f0f0f0;
  max-width: 1000px;
  margin: 0 auto;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  min-height: calc(100vh + 30px);
}

.bm-burger-button {
  height: 1.2em;
  color: #f96332;
  position: fixed;
  top: 30px;
  left: 30px;
  z-index: 2;
  cursor: pointer;
}

.bm-burger-bars {
  background-color: #f96332;
}

.menu-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 3;
}

.bm-overlay {
  background: rgba(0, 0, 0, 0.3);
}

.menu-view .menu-top {
  background: white;
  padding-top: 20px;
  position: sticky;
  top: -130px;
  z-index: 1;
}

.menu-view .menu-body {
  padding: 20px;
  flex: 1;
}

section.menu-footer {
  position: sticky;
  bottom: 0px;
  text-align: center;
  font-size: 12px;
  background: #f96332;
  width: 100%;
  padding: 5px 0;
  color: white;
}

.menu-footer p {
  margin-bottom: 0;
  font-weight: 600;
}

.company-logo {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 30px 0;
}

.company-logo .logo {
  width: 100px;
  border-radius: 50%;
}

.company-name {
  font-weight: 600;
  font-size: 24px;
  margin-bottom: 5px;
}

.sidebar-details .company-name {
  font-weight: 500;
  font-size: 18px;
}

.menu-name {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 5px;
}

.menu-top p.menu-description {
  font-size: 12px;
}

.menu-top .categories {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  max-width: 100%;
}

.cat-box {
  min-width: 150px;
  text-align: center;
  font-weight: 600;
  padding: 5px 30px;
}

.scrollactive-item.cat-box.is-active {
  color: white;
  background: #f96332;
}

a:hover {
  text-decoration: none !important;
}

section.waiter {
  position: fixed;
  bottom: 100px;
  right: 40px;
  z-index: 2;
}

section.waiter .icon-btn {
  background: #f96332;
}

.popover-title {
  color: black !important;
  font-weight: 500;
  font-size: 16px;
}

.waiter-overlay {
  background: #00000059;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
}
</style>